
import { Options, Prop, Vue } from 'vue-property-decorator'

import { fixProtocoll } from '../../utils'

@Options({
  name: 'Image'
})
export default class Image extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  readonly imageUrl!: string

  @Prop({
    type: Boolean,
    default: true
  })
  readonly dimensions!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly mindTheHeight!: boolean

  imgElement: HTMLImageElement | null = null

  srcWidthSizes = [320, 640, 960, 1440]
  srcHeightSizes = [180, 360, 540, 600]

  get fullImgSrc () {
    if (this.imageUrl) {
      let url = fixProtocoll(this.imageUrl) as string
      const queryIndex = url.indexOf('?')
      if (queryIndex >= 0) {
        const params = new URLSearchParams(url.slice(queryIndex + 1))
        if (params.has('size')) {
          params.delete('size')
        }
        url = url.slice(0, queryIndex + 1) + params.toString()
      }
      return url.replace(/\?$/, '')
    }
  }

  get src1x () {
    if (this.fullImgSrc) {
      return this.generateFinalImgSrc(1)
    }
  }

  get src2x () {
    if (this.fullImgSrc) {
      return this.generateFinalImgSrc(2)
    }
  }

  get srcset () {
    if (this.fullImgSrc) {
      return `${this.src1x} 1x, ${this.src2x} 2x`
    }
  }

  get placeholder () {
    return require('../../assets/img/rtl_placeholder_image.svg')
  }

  generateFinalImgSrc (density: number) {
    if (this.fullImgSrc) {
      let param = ''

      const width = this.getMappedWidth(density) || this.srcWidthSizes[0]
      param += width ? `w${width}` : ''

      if (this.mindTheHeight) {
        const height = this.getMappedHeight(density) || this.srcHeightSizes[0]
        param += height ? (width ? `xh${height}` : `h${height}`) : ''
      }

      return this.fullImgSrc + (param.length ? `${this.fullImgSrc.includes('?') ? '&' : '?'}size=${param}` : '')
    }
  }

  getAttrs () {
    const attrs: Record<string, string> = {}

    if (this.isLcp) {
      attrs.fetchpriority = 'high'
    }

    if (this.dimensions) {
      const sizes = this.getSize()
      if (sizes) {
        Object.assign(attrs, sizes)
      }
      if (!this.isLcp) {
        attrs.loading = 'lazy'
      }
    }

    return attrs
  }

  getSize () {
    const target = this.imgElement?.parentElement
    if (target) {
      const size = target.getBoundingClientRect()
      return {
        width: Math.ceil(size.width),
        height: Math.ceil(size.height)
      }
    }
  }

  getMappedWidth (density = 1) {
    return this.getMappedSize(density)
  }

  getMappedHeight (density = 1) {
    return this.getMappedSize(density, true)
  }

  getMappedSize (density = 1, isHeight = false) {
    const size = this.getSize()

    if (size) {
      return isHeight ?
        this.findNearestSize(this.srcHeightSizes, size.height * density) :
        this.findNearestSize(this.srcWidthSizes, size.width * density)
    }
  }

  findNearestSize (sizes: Array<number>, value: number) {
    return sizes.find(size => value <= size) || [...sizes].pop()
  }

  updated () {
    this.imgElement = this.$el
  }

  mounted () {
    this.imgElement = this.$el
  }
}
